// extracted by mini-css-extract-plugin
export default {"container":"style_container__WuOEj","text":"style_text__0nQZ3","pageNotFound":"style_pageNotFound__qn8Q9"};